import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { IMaterialSearchResult, SearchService } from '../../services/common';
import { UtilFns } from '../../utils/common';
import { ModalDialog } from '../../controls/common';

import { MaterialListItem } from '../../entities/projections/MaterialListItem';
import { IMaterialResultsParent, MaterialResultsComponent } from './material-results.component';

@Component({
    selector: 'material-selector',
    templateUrl: './material-selector.html',
})
export class MaterialSelectorComponent extends ModalDialog<MaterialListItem> implements IMaterialResultsParent, OnInit {
    @ViewChild(MaterialResultsComponent, { static: true }) _materialResultsComponent: MaterialResultsComponent;

    _searchTerm: string;
    _entities: MaterialListItem[];

    constructor(public elementRef: ElementRef, public _searchService: SearchService) {
        super(elementRef);
    }

    ngOnInit() {
    }

    canSearch() {
        return this._searchTerm && this._searchTerm.length > 1;
    }

    onSearch() {
        if (!this.canSearch()) {
            return;
        }
        const params: IMaterialSearchResult = {
            materialSearchCode: null,
            materials: [],
            relatedMonographNumbers: null,
            searchDescription: null,
            totalCount: 0,

            searchTerm: this._searchTerm,
            searchType: 'searchall',
            pageNumber: 0,
            pageSize: 20
        };
        this.validationMessage = null;
        this._entities = null;
        // no need to search here; results component grid will perform the search
        this._materialResultsComponent.update(this, params);
    }

    // called from MaterialResultsComponent
    selectMaterial(mli: MaterialListItem) {
        UtilFns.returnModal(this, mli);
    }


}

